import ReactDOM from 'react-dom';

import { SECOND_MS } from '@lootboy/lib/time';

import GoogleTagManager from '~/components/GoogleTagManager';

import { initOneSignal } from '~/middlewares/onesignal';
import { initialiseRecaptcha } from '~/middlewares/recaptcha';
import { initUserCentrics } from '~/middlewares/usercentrics';

import App from './app';

import './i18n';

import './sass/main.scss';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
  dataLayer: [
    'consent',
    'default',
    {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      wait_for_update: 2 * SECOND_MS, // milliseconds to wait for update
    },
  ],
};

if (process.env.REACT_APP_GTM_AUTH) {
  tagManagerArgs.auth = process.env.REACT_APP_GTM_AUTH;
  tagManagerArgs.preview = process.env.REACT_APP_GTM_PREVIEW;
}

initUserCentrics();

GoogleTagManager.initialize(tagManagerArgs);

initialiseRecaptcha();
initOneSignal();

ReactDOM.render(<App />, document.getElementById('root'));
